/**
 * Which listings the send form's ONE listing picker offers — for-sale, rentals or both —
 * from every listings block of the templates being sent. A bundle shares the picker, so
 * the answer has to suit every document in it.
 *
 * A block's `'both'` means that document takes either kind, so it narrows nothing and
 * widens nothing. That is what lets the exclusivity document (one template behind the
 * seller AND the landlord send, written for sale and rental) sit beside the landlord
 * document and still leave the picker on rentals. When it counted as a third opinion,
 * landlord + exclusivity offered sales and seller + exclusivity offered rentals.
 *
 * Only documents that need DIFFERENT kinds (one sale, one rent) widen to `'both'`:
 * hiding listings one document needs is worse than showing extra. An absent filter is
 * the default (`'sale'`), and so is a send with no block at all.
 */
import { DEFAULT_LISTINGS_BLOCK_LISTING_FILTER } from "../../../@types/signatures";
import type { ListingsBlock, ListingsBlockListingFilter } from "../../../@types/signatures";

export function pickerListingFilter(
  blocks: readonly Pick<ListingsBlock, "listingFilter">[]
): ListingsBlockListingFilter {
  const filters = blocks.map((b) => b.listingFilter ?? DEFAULT_LISTINGS_BLOCK_LISTING_FILTER);
  if (filters.length === 0) return DEFAULT_LISTINGS_BLOCK_LISTING_FILTER;
  const specific = new Set(filters.filter((f) => f !== "both"));
  return specific.size === 1 ? [...specific][0] : "both";
}
